<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div *ngIf="!hasError" class="swiper-container" style="position: absolute; left: 0; top: 0; bottom: 0; right: 0">
  <div class="swiper-wrapper">
    <div
      *ngFor="let slide of banners; let i = index"
      class="swiper-slide"
      [ngStyle]="{
        'background-image': slide['bg-url'] ? 'url(' + slide['bg-url'] + ')' : 'none',
        'background-position': '0% 50%',
        'background-size': 'cover',
        'background-repeat': 'no-repeat',
      }"
    >
      <div
        class="slide-content"
        [ngStyle]="{
          color: slide.title_color,
          'flex-direction': getBannerPosition(slide),
        }"
      >
        <div class="slide-content__position">
          <h2 [ngStyle]="{ color: slide.title_color }">{{ slide.title }}</h2>
          <h6 [ngStyle]="{ color: slide.subtitle_color }">{{ slide.subtitle }}</h6>
          <div>
            <a
              [href]="slide.btn.btn_url"
              [ngStyle]="{ color: slide.btn.btn_text_color, 'background-color': slide.btn.btn_color }"
              class="button"
              target="_blank"
            >
              {{ slide.btn.btn_text }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="swiper-pagination"></div>

  <div class="swiper-button-prev" (click)="onPreviousSlideClicked()" *ngIf="isPrevNextVisible">
    <rx-icon name="icon-chevron-left" [size]="30"></rx-icon>
  </div>
  <div class="swiper-button-next" (click)="onNextSlideClicked()" *ngIf="isPrevNextVisible">
    <rx-icon name="icon-chevron-right" [size]="30"></rx-icon>
  </div>

  <!-- <div class="swiper-scrollbar"></div> -->
</div>

<div *ngIf="hasError" class="default-auth-wrapper" style="position: absolute; left: 0; top: 0; bottom: 0; right: 0">
  <h2>Check out RxPhoto’s Knowledge Base</h2>
  <h6>New to RxPhoto? Learn how to create capture sequences, configure digital forms, tags, and more...</h6>
  <rx-button class="blue blue-m" (click)="navigateToKnowledgebase()">Take Me to the Knowledgebase</rx-button>
</div>
